export default function() {
  const promoCtaButtons = document.querySelectorAll(".button-promo");
  const promoPopup = document.querySelector("#promo-popup");
  const btnClosePopup = document.querySelector("#btn-close-promo");

  if(promoCtaButtons.length <= 0 || !promoPopup) return;

  promoCtaButtons.forEach(button => {
    button.addEventListener("click", () => {
      promoPopup.showModal();
      document.querySelector('body').classList.add('overflow-hidden');
    });
  });

  btnClosePopup.addEventListener("click", () => {
    promoPopup.close();
  });

  promoPopup.addEventListener('close', () => {
    document.querySelector('body').classList.remove('overflow-hidden');
  });
}
